import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RciCommonModule } from '@rci/common';
import { TargetedOffersConfigServiceFactory } from '@rci/self-serve-fido/buyflow/targeted-offers-config-service-factory';
import { rogersBankConfigFactory } from '@rci/self-serve-fido/rogers-bank/rogers-bank.config';
import { RogersBankService } from '@rci/self-serve-fido/rogers-bank/rogers-bank.service';

import { AuthenticationService } from '@rci/self-serve-fido/shared/authentication/authentication.service';
import { ApiEndpointConfigService, ApiEndpointService } from '@rci/self-serve-shared';
import { StateService } from '@rci/state-service';
import { DatepickerService } from '@rogers/cdk/form';
import { PopoverModule } from '@rogers/cdk/popover';
import { AccessoriesConfigService, AccessoriesSummaryStoreModule } from '@rogers/self-serve-accessories';
import { COMMON_APP_CONFIG } from '@rogers/self-serve-common';
import { AccountDetailStoreModule, AccountListStoreModule } from '@rogers/self-serve-common/account';
import { AlertStoreModule } from '@rogers/self-serve-common/alert';
import { AlertContentStoreModule } from '@rogers/self-serve-common/alert-content';
import { AppSettingStoreModule } from '@rogers/self-serve-common/app-setting';
import { BillingDetailStoreModule } from '@rogers/self-serve-common/billing-detail';
import { BrtSwitchStoreModule } from '@rogers/self-serve-common/brt-switch';
import { PageContentStoreModule } from '@rogers/self-serve-common/page-content';
import { UserPermissionStoreModule } from '@rogers/self-serve-common/user-permission';
import {
  RogersBankConfigService,
  RogersBankOfferFacadeService,
  RogersBankOfferService,
  RogersBankOfferStoreModule,
} from '@rogers/self-serve-rogers-bank';
import { TargetedOffersConfigService, TargetedOffersStoreModule } from '@rogers/self-serve-targeted-offers';
import { LOCAL_STORAGE } from '@rogers/self-serve-utils/storage';
import { AccountDetailService } from '../state/account/account-detail.service';
import { UserInformationStateFacade } from '../state/user-information/user-information-state.facade';
import { CommonAppConfigFactory } from './config/common-config';
import { ViewContainerRefService } from './view-container-ref/view-container-ref.service';
import { MarketingOptInStoreModule } from '@rogers/self-serve-common/marketing-opt-in';

@NgModule({
  imports: [
    AccessoriesSummaryStoreModule,
    AccountDetailStoreModule,
    AccountListStoreModule,
    AlertContentStoreModule,
    AlertStoreModule,
    AppSettingStoreModule,
    BillingDetailStoreModule,
    BrtSwitchStoreModule,
    PageContentStoreModule,
    RciCommonModule,
    RogersBankOfferStoreModule,
    TargetedOffersStoreModule,
    UserPermissionStoreModule,
    PopoverModule,
    MarketingOptInStoreModule,
  ],
  exports: [RciCommonModule],
  providers: [
    {
      provide: COMMON_APP_CONFIG,
      useClass: CommonAppConfigFactory,
      deps: [
        ApiEndpointService,
        AuthenticationService,
        StateService,
        ViewContainerRefService,
        TranslateService,
        UserInformationStateFacade,
        AccountDetailService,
        LOCAL_STORAGE,
      ],
    },
    {
      provide: AccessoriesConfigService,
      useClass: CommonAppConfigFactory,
      deps: [ApiEndpointService, AuthenticationService, StateService, ViewContainerRefService],
    },
    {
      provide: TargetedOffersConfigService,
      useClass: TargetedOffersConfigServiceFactory,
      deps: [ApiEndpointService, ApiEndpointConfigService],
    },
    DatepickerService,
    DatePipe,
    {
      provide: RogersBankConfigService,
      useFactory: rogersBankConfigFactory,
      deps: [RogersBankService, ApiEndpointService],
    },
    RogersBankOfferService,
    RogersBankOfferFacadeService,
  ],
})
export class SharedModule {}
